<div fxLayout="row" fxLayoutAlign="end end">
  <button class="dialog-close-button" mat-mini-fab color="warn" (click)="dialogRef.close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<app-audit-trail-document [document]="document"
                          (saved)="dialogRef.close()">
</app-audit-trail-document>
